define('models/template/calendar/template-calendar-day',[
    'underscore', 'backbone', 'utils',
    // models & collections
    'models/calendar/day',
    'collections/template/calendar/template-calendar-day-items',
], function(
    _, Backbone, U,
    // models & collections
    MCalendarDay,
    CTemplateCalendarDayItems
) {

    var MTemplateCalendarDay = MCalendarDay.extend({
        idAttribute: '_id',

        getItems: function() {
            var collection = this.items;
            if (!collection) {
                collection = this.items = new CTemplateCalendarDayItems(
                    this.get('items'), {
                        dayId: this.id
                    });
                this.listenTo(this, {
                    'change:items': this.onItemsChange
                });
            }

            return collection;
        },

        ////////////
        // events //
        ////////////

    });

    return MTemplateCalendarDay;
});

